import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/tr';
import MonthSelector from '../selector/month';
import YearSelector from '../selector/year';
import RequestStatusSelector from '../selector/status';
import lastDayOfMonthContainer from '../../../containers/last-day-of-month';
import * as Alert from '../../../helpers/Alert';
import { withNamespaces } from 'react-i18next';

import Datetime from 'react-datetime';
import Switch from 'react-ios-switch';
import { slice } from 'lodash';

class ActionsCard extends React.Component {
  constructor(props) {
    super(props);

    this.changeSelectedYear = this.changeSelectedYear.bind(this);
    this.changeSelectedRequestStatus = this.changeSelectedRequestStatus.bind(this);
    this.changeSelectedMonth = this.changeSelectedMonth.bind(this);
    this.changeRaportStart = this.changeRaportStart.bind(this);
    this.changeRaportEnd = this.changeRaportEnd.bind(this);
    this.filterButton = this.filterButton.bind(this);

    this.state = {
      selectedMonth: 0,
      selectedYear: 0,
      selectedRequestStatus: 'all',
      multiDateReport: {
        start: 0,
        end: 0
      },
      isMultiDate: false,
      dateRangeShow: false,
      switchShow :false
    };
  }

  async componentWillMount() {
    const { filterValue, fetchLastDayOfMonth,i18n } = this.props;
    const { month, year, requestStatus } = filterValue;
    moment.locale(i18n.language === 'en' ? 'en' : 'tr');

    await fetchLastDayOfMonth(new Date().getMonth() + 1, new Date().getFullYear());
    this.setState({
      selectedMonth: month,
      selectedYear: year,
      selectedRequestStatus: requestStatus,
      currentLastDayOfMonth: moment(this.props.lastDayOfMonth).format('DD-MM-YYYY HH:mm')
    });
  }

  componentDidUpdate(prevProps) {
    const {i18n} = this.props;
    if (prevProps.i18n.language !== i18n.language) {
      moment.locale(i18n.language === 'en' ? 'en' : 'tr');
    }
  }

  async onChange() {
    if (this.props.onChange) {
      await this.props.fetchLastDayOfMonth(this.state.selectedMonth, this.state.selectedYear);
      this.setState({ lastDayOfMonth: moment(this.props.lastDayOfMonth).format('DD-MM-YYYY HH:mm') });
      this.props.onChange(this.state.selectedMonth, this.state.selectedYear,
        this.state.selectedRequestStatus,this.state.multiDateReport, this.state.isMultiDate );
    }
  }

  changeSelectedMonth(val) {
    if (this.state.selectedYear === 0) {
      this.setState(
        { selectedMonth: val, selectedYear: new Date().getFullYear() },
        () => this.onChange());
    } else {
      this.setState({ selectedMonth: val }, () => this.onChange());
    }
  }

  changeSelectedRequestStatus(status) {
    this.setState({ selectedRequestStatus: status }, () => this.onChange());
  }

  changeSelectedYear(val) {
    this.setState({ selectedYear: val }, () => this.onChange());
  }

  changeRaportStart(momentDate) {
    let convertToUnixtime
    if (moment.isMoment(momentDate)) {
      convertToUnixtime = moment(momentDate).startOf("day").unix() * 1000;
    }
    this.setState({
      multiDateReport:{...this.state.multiDateReport, start : convertToUnixtime}
     });
  }
  changeRaportEnd(momentDate) {
    let convertToUnixtime = 0
    if (moment.isMoment(momentDate)) {
       convertToUnixtime = moment(momentDate).endOf("day").unix() * 1000;
        this.setState({
          multiDateReport:{...this.state.multiDateReport, end : convertToUnixtime}
        });
      }
  }
  switchOnChange(selected) {
    this.setState({ dateRangeShow: !this.state.dateRangeShow, isMultiDate: selected });
  }

  filterButton(){
      if(this.state.multiDateReport.start === 0 &&  this.state.multiDateReport.end === 0){
        Alert.error('HATA', "Tarihler boş olamaz!");
      }
      else if (this.state.multiDateReport.start > this.state.multiDateReport.end){
        Alert.error('HATA', "Bitiş tarihi başlangıç tarihinden küçük olamaz!");
      }
      else{
        this.onChange()
      }
  }

  render() {
    const { showStatus, isHr, showSwitch, t } = this.props;
    let  formClass = showStatus ?  'form-group col-xs-12 col-md-5' : 'form-group col-xs-12 col-md-7'
      formClass = showSwitch ? formClass + " switchForm" : formClass;
    return (
      <div className="card">
        <div className="content ">
          <div className="row">

            { (showStatus)
              ? (
                <div className="col-md-2">
                  <RequestStatusSelector
                    manager={this.props.manager}
                    isReport={this.props.isReport}
                    filterOptionValue={this.props.filterOptionValue}
                    title={t('status')+" :"}
                    value={this.state.selectedRequestStatus}
                    onChange={this.changeSelectedRequestStatus}
                  />
                </div>
              )
              : (
                (isHr && this.state.selectedMonth !== 0)
                  ? (
                    <div>
                      <div className="col-lg-7">
                        <span>
                          <b>
                          {t('termClosingDate')} :
                            {' '}
                          </b>
                        </span>
                        {this.state.lastDayOfMonth}
                      </div>
                    </div>
                  )
                  : null
              )

              }

         <div className={"row"} style={{ marginLeft: "0px", marginRight: "0px" }}>

           <div className={formClass} style={{paddingTop:'20px', marginBottom:'0'}}>
             {isHr && this.state.selectedMonth !== 0
                  ? (
                         <div className="alert alert-info" role="alert"
                              style={{
                               float: 'left',
                               marginBottom:'0'
                               }}>
                                  <i dangerouslySetInnerHTML={{__html: t('termClosingInfoMessage')}}></i>
                          </div>
                  )
                  : null }
             { showSwitch ?   <Switch
                 className="multiDateSwitch"
                 offColor={"#eee"}
                 checked={this.state.dateRangeShow}
                 onChange={checked => {this.switchOnChange(checked) }}
                 style={{ zIndex:"99999"}}
             /> : null
             }
           </div>
           {this.state.dateRangeShow ?
               <div className={"multiDateForm col-md-5 col-xs-12"}>
             <div className="startDateMutli form-group col-xs-12 col-md-5">
               <label>
                          <span className="required-field">
                              *
                          </span>
                 {' '}
                 {t('startDate')}
               </label>
               <Datetime
                   key={this.props.i18n.language}
                   locale={this.props.i18n.language === 'en' ? 'en' : 'tr'}
                   isValidDate={this.checkDateIsValid}
                   dateFormat="DD-MM-YYYY"
                   timeFormat={false}
                   onChange={this.changeRaportStart}
               />
             </div>
             <div className="endDateMutli form-group col-xs-12 col-md-5">
               <label>
                          <span className="required-field">
                                 *
                          </span>
                 {' '}
                 {t('endDate')}
               </label>
               <Datetime
                   key={this.props.i18n.language}
                   locale={this.props.i18n.language === 'en' ? 'en' : 'tr'}
                   isValidDate={this.checkDateIsValid}
                   dateFormat="DD-MM-YYYY"
                   timeFormat={false}
                   onChange={this.changeRaportEnd}
               />
             </div>
             <div className={"text-center col-md-2"}>
             <button className="btn btn-xs btn-fill btn-danger" onClick={this.filterButton} style={{marginTop:"30px" }} disabled={!this.state.dateRangeShow}>{t('filter')}</button>
             </div>
           </div> :
               <div className={"monthYearForm col-md-5 col-xs-12" }>

             <div className="col-md-6 col-xs-6">
             <MonthSelector
             title={`${t('month')} :`}
             filterOptionValue={this.props.filterOptionValue}
             value={this.state.selectedMonth}
             onChange={this.changeSelectedMonth}
             filterMonth={this.props.filterMonth}
             currentLastDayOfMonth={this.state.currentLastDayOfMonth}
             currentYear={this.state.selectedYear}
             />
             </div>
             <div className="col-md-6 col-xs-6">
             <YearSelector
             title={`${t('year')} :`}
             filterOptionValue={this.props.filterOptionValue}
             value={this.state.selectedYear}
             onChange={this.changeSelectedYear}
             />
             </div>
             </div> }
         </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withNamespaces()(withRouter(connect(...lastDayOfMonthContainer)(ActionsCard)));



// WEBPACK FOOTER //
// ./src/components/common/filter/index.js